import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card.js";
import {Button} from "@/components/ui/button.js";
import {Label} from "@/components/ui/label.js";
import {Input} from "@/components/ui/input.js";
import {useSignal, useSignals} from "@preact/signals-react/runtime";
import {cn} from "@/lib/utils.js";
import {$appName} from "@/js/utilities/name.js";

const LoginForm = ({ className, ...props }) => {
    useSignals()

    const user = useSignal("")
    const password = useSignal("")

    const login = () => {
        fetch("/yi/login", {method: "POST", headers: {"Content-Type": "application/json"},
            body: JSON.stringify({username: user.value, password: password.value})})
            .then(res => { location.href = res.url } )
    }

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-semibold font-[Overpass]">{$appName.value}</CardTitle>
        </CardHeader>
        <CardContent>
        <div className="grid gap-6">
          <div className="flex flex-col gap-4">
              <Button variant="outline" className="w-full">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16">
                      <path
                          d="M6.555 1.375 0 2.237v5.45h6.555zM0 13.795l6.555.933V8.313H0zm7.278-5.4.026 6.378L16 16V8.395zM16 0 7.33 1.244v6.414H16z"/>
                  </svg>
                  Login with Microsoft
              </Button>
              <Button variant="outline" className="w-full">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                          d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/>
                  </svg>
              Login with Google
            </Button>
          </div>
          <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
            <span className="relative z-10 bg-background px-2 text-muted-foreground">
              Or continue with
            </span>
          </div>
          <div className="grid gap-6">
            <div className="grid gap-2">
              <Label htmlFor="username">User</Label>
              <Input
                id="username"
                type="text"
                placeholder="user@yourinsight.com"
                value={user.value}
                onInput={e => user.value = e.target.value}
              />
            </div>
            <div className="grid gap-2">
              <div className="flex items-center">
                <Label htmlFor="password">Password</Label>
                <a href="#" className="ml-auto text-sm underline-offset-4 hover:underline">
                  Forgot your password?
                </a>
              </div>
              <Input
                  id="password"
                  type="password"
                  value={password.value}
                  onInput={e => password.value = e.target.value}
              />
            </div>
            <Button
                className="w-full"
                onClick={login}>
              Login
            </Button>
          </div>
          <div className="text-center text-sm">
            Don&apos;t have an account?{" "}
            <a href="#" className="underline underline-offset-4">
              Sign up
            </a>
          </div>
        </div>
        </CardContent>
      </Card>
    </div>
  )
}

const LoginPage = () => (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-transparent p-6 md:p-10">
        <div className="flex w-full max-w-sm flex-col gap-6">
            <LoginForm/>
        </div>
    </div>
)

const App = () => (
    <>
        <img src="/yi/img/login/login-bg.webp" alt="" style={{ display: "none" }}
             onLoad={() => document.body.style.backgroundImage = "url('/yi/img/login/login-bg.webp')"}/>
        <StrictMode>
            <LoginPage/>
        </StrictMode>
    </>
)

document.title = $appName.value + " \u2014 Login"

createRoot(document.getElementById('app')).render(<App/>)